<template>
  <div>
    <!--弹出框-->
    <el-dialog title="请修改密码" :visible.sync="dialogVisible" :modal="false" v-dialogDrag :before-close="handleClose"
      :close-on-click-modal="false" :show-close="false" :close-on-press-escape="false">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="70px">
        <el-form-item label="原密码" prop="origpass">
          <el-input type="password" v-model="ruleForm.origpass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="pass">
          <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="password" slot="reference">
        <p>修改密码</p>
        <span class="el-icon-edit-outline"></span>
      </div>
    </el-dialog>
    <!--弹出框-->
  </div>
</template>

<script>
  import {password, logouts} from "@/api/api";
  export default {
    data() {
      var origindatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入原密码'));
        } else {
          callback();
        }
      };
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (value.length < 8) {
          callback(new Error('密码不能少于8个字符'));
        } else {
          //判断密码是否符合
          let numArr = value.match(/(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_]).{8,}$/);
          // let numArr = value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}$/);
          if (numArr==null) {
            callback('密码需包括大写字母，小写字母，数字和特殊字符四种类型');
          } else {
            if (this.ruleForm.checkPass !== '') {
              this.$refs.ruleForm.validateField('checkPass');
            }
            callback();
          }
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        dialogVisible: true, //弹出框显示

        ruleForm: {
          origpass: '',
          pass: '',
          checkPass: ''
        },
        rules: {
          origpass: [{
            validator: origindatePass,
            trigger: 'blur'
          }],
          pass: [{
            validator: validatePass,
            trigger: 'blur'
          }],
          checkPass: [{
            validator: validatePass2,
            trigger: 'blur'
          }]
        },
      }
    },
    components: {},
    mounted() {},
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = {
              password: this.ruleForm.origpass,
              newPassword: this.ruleForm.pass
            };
            password(params).then((res) => {
              if (res.code == 500) {
                this.$message.error(res.message);
              } else {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.ruleForm.origpass = '';
                this.ruleForm.pass = '';
                this.ruleForm.checkPass = '';
                this.visible = false;

                //自动登出
                let params1 = {};
                this.$router.replace("siginIn");
                logouts(params1).then((res) => {
                  if (res.code == 200) {
                    window.localStorage.clear();
                    this.$store.commit("toKen", null);
                    this.$store.commit("userId", null);
                    this.$store.commit("naMe", null);
                    this.$store.commit("unIt", null);
                    this.$store.commit("Tel", null);
                    this.$router.replace("siginIn");
                  }
                });

                this.dialogVisible = false;
                this.$emit("getcancel", {
                  "dialogVisible": this.dialogVisible
                })
              }
            });
          } else {
            return false;
          }
        });
      },

      resetForm(formName) {
        this.$refs[formName].resetFields();
      },

      handleClose(done) {
        this.dialogVisible = false;
        this.$emit("getcancel", {
          "dialogVisible": this.dialogVisible
        })
      },
    },
  };
</script>

<style scoped="scoped">
  >>>.el-dialog {
    width: 700px;
  }

  >>>.el-dialog__body {
    height: 200px;
    overflow: auto;
  }
</style>
